import React from 'react';
import confetti from 'canvas-confetti';
import { colors } from '../constants';

type Props = {
  durationSeconds?: number;
};

const colorSet = [colors.sapphire.DEFAULT, colors.sapphire[300], colors.sapphire[100]]

function randomInRange(min: number, max: number): number {
  return Math.random() * (max - min) + min;
}

function randomColorInSet(): string {
  const random = Math.floor(Math.random() * colorSet.length);
  return colorSet[random];
}

export const Confetti = ({ durationSeconds = 15 }: Props): JSX.Element => {
  const duration = durationSeconds * 1000;
  const animationEnd = Date.now() + duration;
  const skewValue = 1;

  (function frame(): void {
    const timeLeft = animationEnd - Date.now();
    const ticks = Math.max(200, 500 * (timeLeft / duration));
    const skew = Math.max(0.8, skewValue - 0.001);

    confetti({
      particleCount: 1,
      startVelocity: 0,
      ticks,
      origin: {
        x: Math.random(),
        // since particles fall down, skew start toward the top
        y: (Math.random() * skew) - 0.2
      },
      colors: [randomColorInSet()],
      shapes: ['circle'],
      gravity: randomInRange(0.4, 0.6),
      scalar: randomInRange(0.4, 1),
      drift: randomInRange(-0.4, 0.4)
    });

    if (timeLeft > 0) {
      requestAnimationFrame(frame);
    }
  }());
  return (
    <div />
  )
};
